// @flow
import type { RoamingActionType } from './actions';
import type { StateType } from '../../reducers';
import type { CountryType } from '../../../config/iddCountries';

export default (state: RoamingStateType = {}, action: RoamingActionType): RoamingStateType => {
  switch (action.type) {
    case 'SET_ROAMING_COUNTRY':
      const { country } = action.payload;
      return {
        ...state,
        country,
      };

    default:
      return state;
  }
};

const roamingStateSelector = (state: StateType) => state.international.roaming;

export function selectedRoamingPackageZoneSelector(state: StateType, withoutPrefix: ?boolean): ?string {
  const roamingState = roamingStateSelector(state);
  const zone = roamingState?.country?.callFromAbroad;
  if (!zone) return undefined;
  return withoutPrefix && zone !== 'ROAM_LIKE_HOME' && zone !== 'EXTENDED_ROAM_LIKE_HOME' ? zone.substr(5) : zone;
}

export function selectedRoamingPackageCountryIdSelector(state: StateType): ?string {
  const roamingState = roamingStateSelector(state);
  return roamingState?.country?.id;
}

export type RoamingStateType = {
  country?: CountryType,
};
